import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '../../../util/logger';

import InvestorBlock from '../InvestorBlock';

interface IProps {
  title: string;
  anchor: string;
}

const IconEmail = () => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 20 20">
      <title>mail-o</title>
      <g id="Web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="07投资者关系_web_第1张图" transform="translate(-614.000000, -6877.000000)" fillRule="nonzero">
          <g id="mail-o" transform="translate(614.000000, 6877.000000)">
            <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="20" height="20" />
            <path
              d="M15.8334718,3.33333333 C17.2141837,3.33333333 18.3334718,4.45262146 18.3334718,5.83333333 L18.3334718,5.83333333 L18.3334718,14.1666667 C18.3334718,15.5473785 17.2141837,16.6666667 15.8334718,16.6666667 L15.8334718,16.6666667 L4.16680517,16.6666667 C2.7860933,16.6666667 1.66680517,15.5473785 1.66680517,14.1666667 L1.66680517,14.1666667 L1.66680517,5.83333333 C1.66680517,4.45262146 2.7860933,3.33333333 4.16680517,3.33333333 L4.16680517,3.33333333 Z M17.0828052,6.29933333 L11.2494446,9.66546397 C10.5315197,10.0796514 9.65911285,10.1092363 8.91911906,9.75421842 L8.75083237,9.66546397 L2.91680517,6.30033333 L2.91680517,14.1666667 C2.91680517,14.8138754 3.40867983,15.3462006 4.03899993,15.4102131 L4.16680517,15.4166667 L15.8334718,15.4166667 C16.5238278,15.4166667 17.0834718,14.8570226 17.0834718,14.1666667 L17.0834718,14.1666667 L17.0828052,6.29933333 Z M15.8334718,4.58333333 L4.16680517,4.58333333 C3.78387336,4.58333333 3.44115875,4.75552362 3.21186516,5.02670038 L9.37548544,8.58273198 C9.71910764,8.78097556 10.1335101,8.80300262 10.4928612,8.64881317 L10.6247916,8.58273198 L16.7884118,5.02670038 C16.5591183,4.75552362 16.2164036,4.58333333 15.8334718,4.58333333 L15.8334718,4.58333333 Z"
              id="形状结合"
              fillOpacity="0.450066413"
              fill="#111925"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

function Contacts(props: IProps) {
  const { title, anchor } = props;
  const { t } = useTranslation('investor');
  const contactContainer = useRef<HTMLDivElement | null>(null);
  const lang = t('langContact');

  const containerCls = `
    w-full rounded-[12px] mb-[30px]
     pt-[24px]
    bg-[#fff] p-[20px]
  `;

  const titleCls = `
    mb-[16px] text-sm font-medium
    lg:mb-[24px] lg:text-xl
  `;

  const remoteContentCls = `
    alert-iframe w-full pb-[25px] mb-[25px]
    border-b border-[#e8e8ea]
  `;

  const disclaimContainerCls = `pt-[24px] text-[#111925] opacity-60 pb-[100px]`;

  useEffect(() => {
    const iframe: HTMLIFrameElement | undefined = contactContainer.current?.childNodes[0] as HTMLIFrameElement;

    if (!iframe) {
      new window.easyXDM.Socket({
        remote: `https://alert.todayir.com/hk/alert_meituan3.php?clientid=1373&lang=${lang}`,
        swf: 'easyxdm.swf',
        container: 'alert-iframe',
        onMessage(message: string) {
          const { container } = this as any;
          container.getElementsByTagName('iframe')[0].style.height = `${message}px`;
          container.getElementsByTagName('iframe')[0].scrolling = 'no';
          container.getElementsByTagName('iframe')[0].style.width = '100%';
        },
      });
    } else {
      const { src } = iframe;

      iframe.setAttribute(
        'src',
        src.replace(/^(.*)(lang=(tc|sc|en))(.*)$/g, (_, p1, p2, p3, p4) => {
          // console.log(p2, p3);
          logger.info(p2);
          logger.info(p3);
          return `${p1}lang=${lang}${p4}`;
        }),
      );
    }
  }, [lang]);

  return (
    <InvestorBlock title={title} anchor={anchor}>
      <div className="border-b border-[#e8e8ea] lg:pb-[30px]">
        <div className={containerCls}>
          <h6 className={titleCls}>{t('titleEmailAlerts')}</h6>
          <div className={remoteContentCls} id="alert-iframe" ref={contactContainer} />
          <div>
            <h6 className={titleCls}>{t('titleContactUs')}</h6>
            <div className="mb-[12px] flex items-center">
              <div className="mr-[4px]">
                <IconEmail />
              </div>
              <div className="text-sm">
                {t('titleEmailAddress')}:
                <a href="mailto:ir@meituan.com" className="ml-[4px] cursor-pointer text-[#0054f7]">
                  ir@meituan.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={disclaimContainerCls}>
        <div className="mb-[9px] text-sm font-medium">{t('titleDisclaim')}</div>
        <p className="text-xs">{t('contentDisclaim')}</p>
      </div>
    </InvestorBlock>
  );
}

export { Contacts };
